import { render, staticRenderFns } from "./PageCards.vue?vue&type=template&id=9d7a5c4c&scoped=true&"
import script from "./PageCards.vue?vue&type=script&lang=js&"
export * from "./PageCards.vue?vue&type=script&lang=js&"
import style0 from "./PageCards.vue?vue&type=style&index=0&id=9d7a5c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a5c4c",
  null
  
)

export default component.exports